import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { List } from '../../shared/list';

import { CaptureAggregate } from '../../_models/capture-aggregate';
import { CaptureAggregateFilter } from '../../_models/capture-aggregate';
import { CaptureAggregateService } from '../../_services/capture-aggregate.service';
import { CaptureImportedService } from '../../_services/capture-imported.service';
import { Profile } from '../../_models/profile';

@Component({
  selector: 'app-captures-list',
  templateUrl: './captures-list.component.html',
  styleUrls: ['./captures-list.component.sass'],
})
export class CapturesListComponent extends List implements OnInit {
  errorMessage: string;
  involved_years: string[] = [];
  filter: CaptureAggregateFilter = new CaptureAggregateFilter();
  public profile: Profile;
  loading: boolean;

  constructor(
    private captureAggregateService: CaptureAggregateService,
    private captureImportedService: CaptureImportedService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(captureAggregateService, new CaptureAggregate(), router, route);
    this.loading = false;
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.route.params.subscribe((routeParams) => {
      this.loading = true;
      if (this.profile.haveAccess('import')) {
        if (this.filter) {
          let newService = this.service;
          if (routeParams['data_type']) {
            if (routeParams['data_type'] === 'dea') {
              newService = this.captureAggregateService;
            } else if (routeParams['data_type'] === 'imports') {
              newService = this.captureImportedService;
            }
          }
          if (newService !== this.service) {
            this.service = newService;
          }
        }
      }
    });
  }

  ngOnInit() {
    this.pageSize = 10000;
    this.initList('captures', this.filter);
  }

  listCallback() {
    this.involved_years = [];
    if (this.collection.length > 0) {
      const totals = this.collection[0].totals;
      for (const total of totals) {
        this.involved_years.push(total['year']);
      }
    }
    this.collection.sort(function (a, b) {
      if (parseFloat(a.average) > parseFloat(b.average)) {
        return -1;
      }
      if (parseFloat(a.average) < parseFloat(b.average)) {
        return 1;
      }
      return 0;
    });
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/captures/captures-list/captures-list.component.ts